import type { LumirEntryTextKey } from './lumir-entry';

export type LumirEntryUtm = Partial<Record<Exclude<LumirEntryTextKey, 'ref'>, string>>;

export interface LumirEntryContractCase {
  name: string;
  written: LumirEntryUtm;
  stored: LumirEntryUtm;
}

// Inputs the frontend writer and the backend reader must clean to the same value.
export const LUMIR_ENTRY_CONTRACT_CASES: readonly LumirEntryContractCase[] = [
  {
    name: 'Cyrillic text',
    written: { us: 'вконтакте', um: 'посев', uc: 'осень' },
    stored: { us: 'вконтакте', um: 'посев', uc: 'осень' },
  },
  {
    name: 'an emoji at the cap, kept whole',
    written: { us: `${'a'.repeat(99)}😀tail` },
    stored: { us: `${'a'.repeat(99)}😀` },
  },
  {
    name: 'a text of exactly 100 characters',
    written: { us: 'ж'.repeat(100), um: 'cpc' },
    stored: { us: 'ж'.repeat(100), um: 'cpc' },
  },
];
